const STORAGE_KEY = 'adult-film-favorites-v1';
const UPDATE_EVENT = 'favorites-updated';

export const readFavorites = (): string[] => {
  if (typeof window === 'undefined') return [];
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter((item): item is string => typeof item === 'string') : [];
  } catch {
    return [];
  }
};

export const writeFavorites = (ids: string[]) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
    window.dispatchEvent(new Event(UPDATE_EVENT));
  } catch {
    // Storage may be unavailable in private mode; fail silently.
  }
};

export const toggleFavoriteId = (id: string): string[] => {
  const current = readFavorites();
  const next = current.includes(id) ? current.filter((item) => item !== id) : [id, ...current];
  writeFavorites(next);
  return next;
};

export const favoritesUpdateEvent = UPDATE_EVENT;